module.exports = __webpack_public_path__ + "static/media/hydrafusion.16d84870.jpg";